// extracted by mini-css-extract-plugin
export default {"container":"loading-bage_container__isAMF"};